import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_4bd9dne99k: FaireCollectionEntity = {
  token: "pbc_4bd9dne99k",
  type: "collection",
  name: "Whimsical Sweater Knit Baby Collection (Organic) - In Stock",
  heroImageUrl:
    "https://cdn.faire.com/fastly/66657aa090fe04a367e7493de6a912654f11e44299c14f205f895a2dd6a01fbc.jpeg",
  itemCount: 64,
  description:
    "Eco-chic baby knits made from 100% ORGANIC COTTON yarn.\n\nFeaturing embroidery, applique, jacquard & unique knitting techniques for sweater knits.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.418Z",
    importedBy: "entity-db-import-collections",
  },
};
